
/*
 * Modules
 */
import './modules/dropdown';
import './modules/tabs';
import './modules/mobile-nav';
import './modules/handle-scrollable';
import { isInViewport } from './modules/is-in-viewport';
import { animateNumbers } from './modules/animate-numbers';
import { showRandomImage } from './modules/show-random-image';

const isInViewportSections = document.querySelectorAll('.js-viewport-detect');

const globalFunctions = {
	animateNumbers,
	showRandomImage,
}

window.addEventListener('scroll', () => {
	isInViewport(isInViewportSections, globalFunctions)

});

window.addEventListener('load', isInViewport(isInViewportSections, globalFunctions))

